<template>
    <div>
        <page-header>
            {{ $t('dashboard.title') }}
            <template #side>
                <ButtonIcon
                    class="mr-2"
                    icon="refresh-cw"
                    variant="link"
                    :disabled="loading"
                    :icon-animation="iconAnimation"
                    @click="reload"
                />
                <TimeRangeCalendar v-model="timeRange" :disabled="loading" :options="['today', 'yesterday', 'last7Days', 'currentWeek', 'last14Days', 'last30days', 'currentMonth', 'currentQuarter', 'currentYear']" />
            </template>
        </page-header>

        <div class="row">
            <div class="col-md-4 mb-4">
                <WidgetStatChart
                    :title="$t('dashboard.clicks')"
                    :value="$format.number(clicks.clicks)"
                    :difference="$format.percent(percentDiff(clicks.clicks, clicks.clicks_compare))"
                    :data="getWidgetChartData('clicks')"
                    :loading="requestClicksStats.getLoading()"
                    :error="requestClicksStats.getError()"
                    :chart-color="chartOverview.clicks.color"
                    tooltip-formatter="round"
                />
            </div>
            <div class="col-md-4 mb-4">
                <WidgetStatChart
                    :title="$t('dashboard.transactions')"
                    :value="$format.number(orders.orders)"
                    :difference="$format.percent(percentDiff(orders.orders, orders.orders_compare))"
                    :data="getWidgetChartData('orders')"
                    :loading="requestOrdersStats.getLoading()"
                    :error="requestOrdersStats.getError()"
                    :chart-color="chartOverview.orders.color"
                    tooltip-formatter="round"
                />
            </div>
            <div class="col-md-4 mb-4">
                <WidgetStatChart
                    :title="$t('dashboard.salesValue')"
                    :value="$format.currency(amount.amount)"
                    :difference="$format.percent(percentDiff(amount.amount, amount.amount_compare))"
                    :data="getWidgetChartData('amount')"
                    :loading="requestAmountStats.getLoading()"
                    :error="requestAmountStats.getError()"
                    :chart-color="chartOverview.amount.color"
                    tooltip-formatter="currency"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-4">
                <MultiEChartCard
                    :data="chartOverview"
                    :loading="isChartOverviewLoading"
                    :title="$t('dashboard.overview')"
                    type="time"
                    @currentChart="setCurrentChart"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-4">
                <WidgetRecentTransactions ref="widgetRecentTransactions" />
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 mb-4">
                <WidgetBestSpaces ref="widgetBestSpaces" :time-range="timeRange || {}" />
            </div>
            <div class="col-xl-6 mb-4">
                <WidgetBestProducts ref="widgetBestProducts" :time-range="timeRange || {}" />
            </div>
        </div>
    </div>
</template>

<script>
    import DashboardMixin from '@/views/common/dashboard/index.vue';

    export default {
        name: 'AdvertiserDashboard',
        mixins: [DashboardMixin],
        data() {
            return {
                currentChart: 'clicks',
            };
        },
        computed: {
            campaignId() {
                return this.$store.getters['campaigns/getCurrentCampaign']?.id;
            },
            loading() {
                return (
                    this.requestClicksStats.getLoading() ||
                    this.requestOrdersStats.getLoading() ||
                    this.requestAmountStats.getLoading() ||
                    this.requestUserTransactions.getLoading() ||
                    this.requestSpaceReport.getLoading() ||
                    this.requestTopProductsQuantity.getLoading() ||
                    this.isChartOverviewLoading
                );
            },
            iconAnimation() {
                return this.loading ? 'spin' : undefined;
            },
            chartOverview() {
                return {
                    clicks: this.getChartData(this.clicks.chart, 'clicks', this.$t('dashboard.clicks'), '#f77e53'),
                    orders: this.getChartData(this.orders.chart, 'orders', this.$t('dashboard.transactions'), '#43d39e'),
                    commission: this.getChartData(this.commission.chart, 'advertiser_commission', this.$t('dashboard.commission'), '#ffbe0b', 'currency'),
                    amount: this.getChartData(this.amount.chart, 'amount', this.$t('dashboard.salesValue'), '#890070', 'currency'),
                };
            },
        },
        watch: {
            campaignId() {
                this.fetchData();
            },
        },
        methods: {
            fetchData(params = {}) {
                this.fetchClicksStats(params);
                this.fetchOrdersStats(params);
                this.fetchCommissionStats(params);
                this.fetchAmountStats(params);
            },
            reload() {
                const params = { cache: false };
                this.fetchData(params);
                this.$refs.widgetRecentTransactions.fetchData(params);
                this.$refs.widgetBestSpaces.fetchData(params);
                this.$refs.widgetBestProducts.fetchData(params);
            },
        },
    };
</script>
